import React from 'react';
import {List, Card} from 'antd';
import PropTypes from 'prop-types';

import NodeInfoTextGeneralEditModal from "@/components/mainView/nodeInfo/main.nodeInfo.text.general.edit";
import {NodeInfoUpdatingStatus} from "@/libs/view/network/status";
import ViewDataProvider from '@/components/common/dataProvider/common.dataProvider.view';
import NodeInfoCommonDetailPanel from "@/components/mainView/nodeInfo/main.nodeInfo.common.detail";
import {
  getNodeDisplayTitle,
  getNodeIcon,
} from "@/constants/vis.defaultDefine.1";
import Icon from "@/components/common/common.icon";
import PB, {SimplePB} from "@/libs/simplePB";

class NodeInfoTextGeneralPanel extends React.Component {
  state = {
    editModalVisible: false,
  };

  formRef = undefined;

  onEdit = () => {
    this.setState({editModalVisible: true});
  };

  onSave = () => {
    let me = this;
    const form = me.formRef.props.form;
    form.validateFields((err, values) => {
      if (!err && me.props.userInfo) {
        console.log('Received values of form: ', values);
        // 用户标签信息中的名称、描述和链接可编辑
        const {name, description, url/*, tags*/} = values;
        const nodeInfo = {
          ...me.props.node,
          fname: name,
          label: name,
          // tag: tags.join(' '),
          description,
          url,
          meta: {
            ...me.props.node.meta,
            description,
            url,
          },
          userId: this.props.userInfo.userId,
        };
        // noinspection JSIgnoredPromiseFromCall, JSCheckFunctionSignatures
        me.props.networkRef && me.props.networkRef.updateNodeInfo(nodeInfo);
      }
    });
  };

  render() {
    const {node, /*permanent, */showIcon, showAssistant, editable, userInfo, updatingStatus, networkRef} = this.props;
    const records = (node ? [node] : []);
    let me = this;
    if (updatingStatus === NodeInfoUpdatingStatus.SUCCESS && me.state.editModalVisible) {
      requestAnimationFrame(() => {
        me.setState({editModalVisible: false});
      });
    }
    const {name, type, color} = getNodeIcon(node);

    return (
      <Card bordered={false}
            title={
              <span>
                <a
                  style={{
                    '--extra-action-width': node._$extraTitleActions ? node._$extraTitleActions._$width : '0em',
                  }}
                >
                  <Icon name={name} type={type} color={color} style={{marginRight: '0.5em'}} />
                  <span><span>{getNodeDisplayTitle(node)}</span></span>
                </a>
                {
                  node._$extraTitleActions ? node._$extraTitleActions() : null
                }
              </span>
            }

            /*extra={
              (editable && userInfo && networkRef) ?
                <NodeActions
                  userInfo={userInfo}
                  node={node}
                  networkRef={networkRef}
                  extraButtons={{
                    editNode: {
                      title: '编辑',
                      tip: '编辑用户标签信息',
                      icon: 'edit',
                      action: e => {
                        e.preventDefault();
                        me.onEdit();
                      }
                    }
                  }}/> : null
            }*/>
        {/*{permanent ? null : <Alert message="该节点为系统自动联想节点" type="info" showIcon/>}*/}
        <List itemLayout="horizontal"
              split={false}
              size="small"
              locale={{emptyText: this.props.emptyText}}
              dataSource={records}
              renderItem={
                (node) => (
                  <List.Item>
                    <NodeInfoCommonDetailPanel 
                      bus={me.props.PB}
                      node={node} 
                      showIcon={showIcon}
                      showAssistant={showAssistant}
                      networkRef={networkRef}
                      originalViewId={me.props.networkRef ? me.props.networkRef.getData().viewId : me.props.originalViewId}
                    />
                  </List.Item>
                )
              }/>
        {
          (node.status === 1 && editable && userInfo) ? (
            <NodeInfoTextGeneralEditModal
              wrappedComponentRef={(formRef) => {
                this.formRef = formRef;
              }}
              text={node.fname}
              description={node.description || ''}
              url={node.url || ''}
              // tags={node.tags}
              visible={this.state.editModalVisible}
              processing={this.props.updatingStatus === NodeInfoUpdatingStatus.PROCESSING}
              onSave={this.onSave}
              onCancel={() => {
                this.setState({editModalVisible: false});
              }}
            />
          ) : null
        }
      </Card>
    );
  }
}

NodeInfoTextGeneralPanel.defaultProps = {
  bus: PB,
  permanent: true,
  showIcon: true,
  showAssistant: false,
  emptyText: '没有选中产业对象',
  editable: false,
  updatingStatus: NodeInfoUpdatingStatus.IDLE,
};

NodeInfoTextGeneralPanel.propTypes = {
  bus: PropTypes.instanceOf(SimplePB),
  node: PropTypes.object.isRequired,
  userInfo: PropTypes.object,
  permanent: PropTypes.bool,
  showIcon: PropTypes.bool,
  showAssistant: PropTypes.bool,
  emptyText: PropTypes.string,
  editable: PropTypes.bool,
  updatingStatus: PropTypes.string,
  networkRef: PropTypes.instanceOf(ViewDataProvider),
  originalViewId: PropTypes.string,
};

export default NodeInfoTextGeneralPanel;
